import { useEffect, useState } from 'react';
import { Box, Button,  Notification, Group, Text,  Loader, Menu,  SimpleGrid, TextInput, Select } from '@mantine/core';
import { IconCheck, IconAlertCircle, IconPlus, IconSelector} from '@tabler/icons-react';
import { makeGetRequest, makePostRequest } from '../services/httpHelper';
import {  IBank, ICampaignPaymentMethod, IPaymentMethod } from '../types';

import { isErrorObject } from '../utils/utils';
import ErrorHandler from '../services/ErrorHandler';

interface ManageCampaignPaymentMethodsProps{
    campaignId:string
}


const ManageCampaignPaymentMethods: React.FC<ManageCampaignPaymentMethodsProps> = ({ campaignId }) => {
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [paymentMethod, setPaymentMethod] = useState<ICampaignPaymentMethod | null>(null);
    const [paymentOptions, setPaymentOptions] = useState<IPaymentMethod[]>([]);
    const [availableMethods, setAvailableMethods] = useState<IPaymentMethod[]>([]);
    const [method, setMethod] = useState<string>("");
    const[showAddPaymentMethodForm,setShowAddPaymentMethodForm] =useState(false)
    const [banks, setBanks] = useState<IBank[]>([]);
    const [selectedBank, setSelectedBank] = useState('');

    



    const [values, setValues] = useState({
            mpesa_number: '',
            mpesa_name:  '',
            paypal_email:  '',
            bank_name:  '',
            account_name:"",
            account_number:'',
            branch:"",
           
    
            
        });

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const { name, value } = e.target; // Extract name and value from event
            setValues((prevValues) => ({
                ...prevValues,
                [name]: value, // Set the correct field dynamically
            }));
        };

        const handleBankChange = (value: string) => {
            setSelectedBank(value);
         
        };
        


            const handleAddPmt =(pmt:string)=>{
                setMethod(pmt.toUpperCase())
                setShowAddPaymentMethodForm(true);
            }

    useEffect(() => {
        const fetchCampaignData = async () => {
            setIsLoading(true);
            try {
                const [campaignRes, methodsRes] = await Promise.all([
                    makeGetRequest(`campaign-payment-method/${campaignId}`),
                    makeGetRequest('payment-services'),
                ]);

                if (isErrorObject(campaignRes)) setError(ErrorHandler(campaignRes));
                else setPaymentMethod(campaignRes.data);

                if (isErrorObject(methodsRes)) setError(ErrorHandler(methodsRes));
                else {
                    setPaymentOptions(methodsRes.data);
                  // const supportedMethods = methodsRes.data;

                    const existingMethods = new Set(
                        [
                            paymentMethod?.mpesa_number ? 'mpesa' : null,
                            paymentMethod?.paypal_email ? 'paypal' : null,
                            paymentMethod?.bank_name ? 'bank' : null,
                        ].filter(Boolean) // This removes nulls/undefined/false
                    );

                    const available = paymentOptions.filter(
                        (method: IPaymentMethod) => !existingMethods.has(method.payment_service.toLowerCase())
                    );
                    setAvailableMethods(available);
                }
            } catch (e) {
                setError('Failed to fetch data');
            } finally {
                setIsLoading(false);
            }
        };

        const getBanks = async () => {
            setIsLoading(true);
            const res = await makeGetRequest('banks');
    
            if (isErrorObject(res)) {
                setIsLoading(false);
                const errorMessage = ErrorHandler(res);
                setError(errorMessage);
            } else {
                const results = res.data;
                setBanks(results);       
                setIsLoading(false);
                setError(null);
            }
        };

        fetchCampaignData();
        getBanks();
    }, [campaignId]);

    const handleAddPaymentMethod = async(e:React.FormEvent) => {
        e.preventDefault()
        //validate input
        switch(method.toLocaleLowerCase()){
            case 'm-pesa':
                if(!values.mpesa_number || !values.mpesa_name){
                    alert("Enter MPESA number and name");
                    return;
                }
                break;
          
            case 'paypal':
                if(!values.paypal_email){
                    alert("Enter PayPal Email Address");
                    return;
                }
                break;

                case 'bank':
                    if(!selectedBank || !values.account_name || !values.account_number || !values.account_number || !values.branch){
                        alert("All bank fields are required")
                        return;
                    }
                break;
                default:
                    alert('Invalid payment method selected');
                    break;

        }
        // Implement the logic for opening a modal or form for adding the selected method
        const data ={
            method:method.toLocaleLowerCase()==='m-pesa'?'mpesa':method.toLocaleUpperCase(),
            mpesa_number:values.mpesa_number,
            mpesa_name:values.mpesa_name,
            paypal_email:values.paypal_email,
            bank_name:selectedBank,
            account_name:values.account_name,
            account_number:values.account_number,
            branch:values.branch,
            campaign_id:campaignId
        }
        const res = await makePostRequest(`campaign/add-payment-method`,data);

        if (isErrorObject(res)) {
            setIsLoading(false);
            const errorMessage = ErrorHandler(res);
            console.log(errorMessage)
            setError(errorMessage);
            setSuccess(true)
            alert('Payment method added')
        } else {
            setIsLoading(false);
            setError(null);
        }
    };

    return (
        <Box mx="auto" p="md">
            {error && <Notification icon={<IconAlertCircle size={18} />} color="red" mb="lg">{error}</Notification>}
            {success && <Notification icon={<IconCheck size={18} />} color="green" mb="lg">{success}</Notification>}

            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <Group position="apart" mb="md">
                        <Text weight={500} size="lg">Manage Campaign Payment Options</Text>
                        {paymentOptions.length > 0 && (
                            <Menu shadow="md" width={200}>
                                <Menu.Target>
                                    <Button leftIcon={<IconPlus />}>Add Payment Method</Button>
                                </Menu.Target>
                                <Menu.Dropdown>
                                    {availableMethods.map((method) => (
                                        <Menu.Item
                                            key={method.id}
                                            onClick={() => handleAddPmt(method.payment_service)}
                                            disabled={method.disabled}
                                        >
                                            {method.payment_service.toUpperCase()}
                                        </Menu.Item>
                                    ))}
                                </Menu.Dropdown>
                            </Menu>
                        )}
                    </Group>

                   
                        {paymentMethod?.mpesa_number && <Text> M-PESA - {paymentMethod.mpesa_number} ({paymentMethod.mpesa_name})</Text>}<br/>
                        {paymentMethod?.paypal_email && <Text> PAYPAL - {paymentMethod.paypal_email}</Text>}<br/>
                        {paymentMethod?.bank_name && <Text> Bank - {paymentMethod.bank_name}, Account Name: {paymentMethod.account_name} ({paymentMethod.account_number})</Text>}<br/>
                
                </>
            )}

           {
            showAddPaymentMethodForm &&
            <>
            
                        {success && (
                            <Notification icon={<IconCheck size={18} />} color="green" mb="lg">
                                Payment Method Added 
                            </Notification>
                        )}

            <SimpleGrid cols={2} breakpoints={[{maxWidth: 'sm', cols: 1}]}>
                {
                    method.toString()==='M-PESA' && <>
                    {
                        !paymentMethod?.mpesa_number ?
                        <>
                                                <TextInput 
                                                    label="Mpesa Number"
                                                     name="mpesa_number" 
                                                     value={values.mpesa_number}
                                                     onChange={handleChange}
                                                     />
                                                    <TextInput 
                                                    label="MPesa Name"
                                                     name="mpesa_name" 
                                                     value={values.mpesa_name}
                                                     onChange={handleChange}
                                                     />
                        
                        </>
                        :
                        <Notification icon={<IconAlertCircle size={18} />} color="red" mb="lg">MPESA account already set</Notification>
                    }


                                                
                    
                    </>
                }


                                                    
                                                   {
                                                    method.toString()==="PAYPAL" && 
                                                    <>
                                                    {
                                                         paymentMethod?.paypal_email ? 
                                                         <Notification icon={<IconAlertCircle size={18} />} color="red" mb="lg">You already have PayPal Email onboard</Notification>
                                                         :
                                                         ( <TextInput
                                                            label="PayPal Email" 
                                                            mb="xs" name="email"
                                                            value={values.paypal_email}
                                                            onChange={handleChange}
                                                             />)

                                                    }
                                                    
                                                    </>
                                                    
                                                    
                                                    
                                                  
                                                   }
                                                      <br/>
                                                      {
                                                        method.toString()==="BANK" && 
                                                        <>
                                                        {
                                                            !paymentMethod?.bank_name?
                                                            <>

                                       <Select
                                        label="Your Bank"
                                         value={selectedBank}
                                        onChange={handleBankChange}
                                        data={banks.map(bank => ({ value: bank.bank_name, label: `${bank.bank_name} ` }))}
                                                            />
                                                      
                                                    <TextInput
                                                     label="Account Name" 
                                                     mb="xs" name="account_name"
                                                     value={values.account_name}
                                                     onChange={handleChange}
                                                      />

                                                    <TextInput
                                                     label="Account Number" 
                                                     mb="xs" name="account_number"
                                                     value={values.account_number}
                                                     onChange={handleChange}
                                                      />
                                                       <TextInput
                                                     label="Branch" 
                                                     mb="xs" name="branch"
                                                     value={values.branch}
                                                     onChange={handleChange}
                                                      />
                                                            </>
                                                            :
                                                <Notification icon={<IconAlertCircle size={18} />} color="red" mb="lg">MPESA account already set</Notification>

                                                        

                                                        }
                                                        
                                                        </>
                                                      }


                                                    
                                                </SimpleGrid>
                                                <Button
                                                    leftIcon={<IconSelector size={18}/>}
                                                    mx="auto"
                                                    variant="light"
                                                    type='submit'
                                                    onClick={handleAddPaymentMethod}

            
                                                >
                                                   Add Now
                                                </Button>
            </>
           }
        </Box>
    );
};

export default ManageCampaignPaymentMethods;

